import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom, of } from 'rxjs';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';

export function preloadLanguage(translocoService: TranslocoService) {
  return () => {
    const regex = /language\/([^\\/?\s]+)/;
    const match = window.location.href.match(regex);
    const language = match?.[1] ?? 'engb';
    translocoService.setActiveLang(language);
    return lastValueFrom(translocoService.load(language));
  };
}

export function initializeEnvironmentConfig() {
  return () => {
    const url = window.location.href.toLowerCase();
    const isCn = url.includes('agridencecn');
    if (isCn) {
      environment.CRD_API = environment.CRD_API_CN;
      environment.TRACEABILITY_API = environment.TRACEABILITY_API_CN;
    }
    return of(true);
  };
}

export function preLoadToken(authService: AuthService): () => boolean {
  return () => {
    const match = window.location.pathname.match(/\/token\/([^/]+)/);
    const token = match?.[1];
    if (token) authService.userInfoToken = decodeURIComponent(token);
    return true;
  };
}
